import { IPricingProfileAdminUserForm } from './types';

export const mapUpsertPricingProfileAdminUser = (data: IPricingProfileAdminUserForm) => {
  return {
    pricingProfileCorporateUser: {
      corporateUserId: data.corporateUser.id,
      pricingProfileId: data.pricingProfileId,
    },
  };
};
